/**
 * Requirement-text length: the two bounds the server enforces, and the
 * state a live counter should show against them (Questions/Intake layout
 * slice, Ashok rulings 3 and 4, 2026-09-03).
 *
 * DISPLAY ONLY. Nothing here blocks anything. The bounds are enforced
 * server-side, with a 400, in routes/procurement.py's
 * _validate_requirement_text (and its inline copy in
 * update_procurement_intake); this module exists so a buyer under the
 * floor or over the ceiling learns it while typing rather than at submit.
 * It is a JS twin of those two literals and is registered as such in
 * CLAUDE.md's mirror-pair table - change a bound there, change it here.
 *
 * TWO BASES, ONE DISPLAYED NUMBER. The server measures the FLOOR on
 * stripped text (`len(text.strip()) < 10`) and the CEILING on the raw
 * text (`len(text) > 5000`), so a pasted value with enough surrounding
 * whitespace can be over the ceiling and under the floor at once. The
 * counter shows the RAW count, because that is the number the ceiling
 * message will quote and the one a buyer can verify by looking at what
 * they pasted; the floor is evaluated on the trimmed text, because that
 * is what the server compares to 10 - it is reported as a STATE ("at
 * least 10 characters of text needed"), not as a second number, so the
 * two bases never appear as two disagreeing counts. Both states can be
 * true together, and when they are the counter says both, exactly as the
 * server would refuse for either.
 */
export const REQUIREMENT_MIN_CHARS = 10;
export const REQUIREMENT_MAX_CHARS = 5000;

export const requirementLengthState = (value) => {
  const raw = typeof value === 'string' ? value : '';
  const rawCount = raw.length;
  const trimmedCount = raw.trim().length;
  return {
    rawCount,
    trimmedCount,
    underFloor: trimmedCount < REQUIREMENT_MIN_CHARS,
    overCeiling: rawCount > REQUIREMENT_MAX_CHARS,
  };
};
